module.exports = __webpack_public_path__ + "images/top_icon_screen.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top_icon_screen.png
// module id = 900
// module chunks = 121